import { render } from "./CartComponent.vue?vue&type=template&id=bd0994e4&scoped=true"
import script from "../js/cart-component.js?vue&type=script&lang=js&external"
export * from "../js/cart-component.js?vue&type=script&lang=js&external"

import "./CartComponent.vue?vue&type=style&index=0&id=bd0994e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd0994e4"]])

export default __exports__